import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Send } from 'lucide-react';

const Contact: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // In a real application, you'd hook this up to an API or service like EmailJS
        window.location.href = `mailto:hello@example.com?subject=Portfolio Contact from ${formData.name}&body=${formData.message} (%0A%0A From: ${formData.email})`;
    };

    return (
        <section className="px-4 py-16 md:py-24 border-t border-border">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="max-w-xl mx-auto flex flex-col items-center text-center"
            >
                <div className="flex items-center justify-center p-3 rounded-full bg-accent mb-6">
                    <Mail className="w-8 h-8 text-foreground" />
                </div>

                <h2 className="text-3xl font-bold tracking-tight text-foreground mb-4">
                    Get in Touch
                </h2>

                <p className="text-muted-foreground mb-10">
                    Have a project in mind or just want to say hi? I'd love to hear from you.
                    Drop a message and I'll get back to you as soon as possible.
                </p>

                <form onSubmit={handleSubmit} className="w-full space-y-4 text-left">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <label htmlFor="name" className="text-sm font-medium text-foreground">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-foreground/20 text-foreground placeholder:text-muted-foreground/50 transition-shadow"
                                placeholder="John Doe"
                            />
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="email" className="text-sm font-medium text-foreground">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="w-full px-3 py-2 bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-foreground/20 text-foreground placeholder:text-muted-foreground/50 transition-shadow"
                                placeholder="john@example.com"
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label htmlFor="message" className="text-sm font-medium text-foreground">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            rows={4}
                            className="w-full px-3 py-2 bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-foreground/20 text-foreground placeholder:text-muted-foreground/50 transition-shadow resize-none"
                            placeholder="Hi, I'd like to talk about..."
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full py-3 px-4 bg-foreground text-background font-medium rounded-md hover:bg-foreground/90 transition-colors flex items-center justify-center gap-2 group"
                    >
                        <span>Send Message</span>
                        <Send size={16} className="group-hover:translate-x-1 transition-transform" />
                    </button>
                </form>
            </motion.div>
        </section>
    );
};

export default Contact;
